import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import TitlePage from '../../components/general/TitlePage/TitlePage';
import ArticleCard from '../../components/extern/ArticleCard/ArticleCard';
import ArticleData from '../../utils/dataArticle';
import { gsap } from 'gsap';

const getUniqueCategories = (articles) => {
  const categories = articles.map(article => article.category || 'Outros');
  return [...new Set(categories)];
};

const SpecsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const containerRef = useRef();

  const filteredArticles = ArticleData.filter(article =>
    selectedCategory === 'Todos' || article.category === selectedCategory
  );

  useEffect(() => {
    const cards = containerRef.current?.querySelectorAll('.article-card');
    if (cards) {
      gsap.fromTo(cards, { y: 20, opacity: 0 }, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        duration: 0.4,
        ease: 'power2.out'
      });
    }
  }, [selectedCategory]);

  const categories = getUniqueCategories(ArticleData);

  return (
    <main className="container">
      <TitlePage
        title="Explore Artigos"
        subtitle="Conteúdo técnico e estratégico de qualidade para seu dia a dia."
      />

      <Helmet>
        <title>Explore Articles</title>
      </Helmet>

      <div className="filter-section">
        <label htmlFor="categoryFilter">Categoria:</label>
        <select
          id="categoryFilter"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="Todos">Todos</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      <div className="article-grid" ref={containerRef}>
        {filteredArticles.length > 0 ? (
          filteredArticles.map((a, i) => (
            <ArticleCard
              key={i}
              title={a.title}
              url={a.url}
              isDisabled={!a.url}
              category={a.category}
            />
          ))
        ) : (
          <ArticleCard title="Nenhum artigo disponível" isDisabled />
        )}
      </div>
    </main>
  );
};

export default SpecsPage;
